import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-cd1ded1a")
const _hoisted_1 = { class: "p-d-none p-d-md-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "p-mr-3 p-mt-2" }, "Azioni:", -1)
const _hoisted_3 = { class: "p-d-flex p-jc-center p-d-md-none" }
const _hoisted_4 = { class: "p-d-flex p-jc-center p-d-md-none" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createBlock(_component_Toolbar, { class: "p-mb-3 order_toolbar" }, {
    start: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: _ctx.isACCEPTED ? 'Accettato' : 'Accetta',
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isACCEPTED }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('accept')))
        }, null, 8, ["disabled", "label", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: _ctx.isREJECTED ? 'Rifiutato' : 'Rifiuta',
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isREJECTED }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reject')))
        }, null, 8, ["disabled", "label", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: _ctx.isASSIGNED ? 'Assegnato' : 'Assegna',
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isASSIGNED }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('assign')))
        }, null, 8, ["disabled", "label", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: "Attesa ritiro",
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isW_PICKUP }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('waitingPickup')))
        }, null, 8, ["disabled", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: "Ritirato",
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isPICKED_UP }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('pickedUp')))
        }, null, 8, ["disabled", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: "Attesa consegna",
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isW_DROPOFF }]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('waitingDropoff')))
        }, null, 8, ["disabled", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: "Consegnato",
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isDROPPED_OFF }]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('droppedOff')))
        }, null, 8, ["disabled", "class"]),
        _createVNode(_component_Button, {
          disabled: _ctx.$attrs.disabled,
          label: _ctx.isCANCELED ? 'Annullato' : 'Annulla',
          class: _normalizeClass(["p-mr-1 p-button", { 'p-button-outlined': !_ctx.isCANCELED }]),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('cancel')))
        }, null, 8, ["disabled", "label", "class"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(`order-badge status-${_ctx.order.status}`)
        }, _toDisplayString(_ctx.$t(`order.status_${_ctx.order.status}`)), 3)
      ])
    ]),
    end: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_SplitButton, {
          label: "Cambia stato",
          icon: "pi pi-angle-right",
          model: _ctx.orderActionsMenu
        }, null, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}